import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import { useApiMutation } from "@/api/hooks/useApiMutation";
import { validateDraft as validateDraftMutation } from "@/entities/DataAssociation/DataAssociation.mutations";
import clsx from "clsx";
import { useDraft } from "../../hooks/useDraft";
import ValidationCheck from "./ValidationCheck";
import { useEffect, useState } from "react";
import { DraftValidation } from "@/entities/DataAssociation/Draft.model";
import { showCommitPanelAtom } from "../../Labeling.state";
import { useSetAtom } from "jotai";
import { Spinner } from "@/ui/atoms/Spinner";
import { commitDraft as commitDraftMutation } from "@/entities/DataAssociation/DataAssociation.mutations";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";

export function DraftCommitPanel() {
    const setShowCommitPanel = useSetAtom(showCommitPanelAtom);
    const setRightDrawerOpen = useSetAtom(rightDrawerOpenAtom);
    const [validations, setValidations] = useState<DraftValidation>({
        completeness: {
            status: "loading",
            messages: [],
        },
        accountNaming: {
            status: "loading",
            messages: [],
        },
    });
    const isValid = !Object.values(validations).some(
        (validation) =>
            validation.status === "fail" || validation.status === "loading",
    );
    const { mutate: validate } = useApiMutation(validateDraftMutation, {
        onSuccess: (response) => {
            setValidations(response);
        },
    });
    const { mutate: commit, isPending } = useApiMutation(commitDraftMutation, {
        onSuccess: () => {
            setShowCommitPanel(false);
            setRightDrawerOpen(false);
        },
    });
    const { draftWithEdits } = useDraft();

    useEffect(() => {
        validate({ draft: draftWithEdits });
    }, []);

    return (
        <div className="flex flex-col pt-6">
            <RightSidebarButton />
            <h2 className="pageheading">Labeling Checklist</h2>
            <p className="body-s subdued">
                The following checks must pass before the file can be marked as
                labeled.{" "}
            </p>
            <ul className="mt-4 flex flex-col gap-4">
                <li>
                    <ValidationCheck
                        title="Completeness"
                        description="All rows must have an account name and label."
                        status={validations.completeness.status}
                    />
                </li>
                <li>
                    <ValidationCheck
                        title="Account Naming"
                        description="All account names must be unique."
                        status={validations.accountNaming.status}
                    />
                </li>
            </ul>
            <div
                className={clsx(
                    "bg-default w-full p-6",
                    "absolute inset-x-0 bottom-0",
                )}
            >
                <button
                    className="primary xl w-full"
                    disabled={!isValid || isPending}
                    onClick={() => commit({ draft: draftWithEdits })}
                >
                    Commit draft {isPending && <Spinner />}
                </button>
            </div>
        </div>
    );
}
